var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComplete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/tick-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/tick-circle_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tick-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.99998 1.83301C4.32665 1.83301 1.33331 4.82634 1.33331 8.49967C1.33331 12.173 4.32665 15.1663 7.99998 15.1663C11.6733 15.1663 14.6666 12.173 14.6666 8.49967C14.6666 4.82634 11.6733 1.83301 7.99998 1.83301ZM11.1866 6.96634L7.40665 10.7463C7.31331 10.8397 7.18665 10.893 7.05331 10.893C6.91998 10.893 6.79331 10.8397 6.69998 10.7463L4.81331 8.85967C4.61998 8.66634 4.61998 8.34634 4.81331 8.15301C5.00665 7.95967 5.32665 7.95967 5.51998 8.15301L7.05331 9.68634L10.48 6.25968C10.6733 6.06634 10.9933 6.06634 11.1866 6.25968C11.38 6.45301 11.38 6.76634 11.1866 6.96634Z",
    fill: "#3EBF8F"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplete);
export default __webpack_public_path__ + "static/media/complete.4041f7c2435c38716419b6c36eccaa35.svg";
export { ForwardRef as ReactComponent };